const Icon = ({ name, className }) => {
    return <i className={"large material-icons icon " + className}>{name}</i>;
};

export default Icon;
